import Translation from './translation'

export default class Blog extends Translation
{
    get active_ar() {
        return this.locales.includes('ar');
    }

    get active_en() {
        return this.locales.includes('en');
    }
    
    get active_fa() {
        return this.locales.includes('fa');
    }

    constructor(blog){
        super()
        this.id             = 0
        
        this.locales        = []
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.content_ar     = ''
        this.content_en     = ''
        this.content_fa     = ''

        this.published      = false

        this.tags           = []

        this.editor_images  = []
        this.map(blog)
        this.init()
    }

    map(blog){
        if(blog == undefined) return
        this.id             = blog.id
        
        this.published      = blog.published_at != null
        this.tags           = blog.tags??[]
        this.created_at     = blog.created_at  
        this.updated_at     = blog.updated_at  
        this.published_at   = blog.published_at  

        for (let locale in blog.translations) {
            this['title_' + locale] = blog.translations[locale].title
            this['content_' + locale] = blog.translations[locale].content
            this.locales.push(locale);
        }
        this.setLocale(this.locales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.locales){

            fData.append('translation['+ locale +'][title]', this['title_'+ locale]);
            fData.append('translation['+ locale +'][content]', this['content_'+ locale]);
        }
        
        fData.append('published', Number(this.published));

        this.tags.forEach(tag=>fData.append('tags[]', tag))

        this.editor_images.forEach(img=>fData.append('editor_images[]', img.id))
        
        return fData
    }
}

